import {ApiV0} from '../api.v0';
import {RestApiService} from '../../rest-api.service';
import {ApiV0RmCalendar} from './resource-manager/api.v0.rm.calendar';
import {ApiV0RmCompany} from './resource-manager/api.v0.rm.company';

export class ApiV0ResourceManager {
    segment: string

    constructor(v0: ApiV0, api: RestApiService) {
        this.segment = v0.segment + '/RM';
        this.calendar = new ApiV0RmCalendar(this, api)
        this.company = new ApiV0RmCompany(this, api)
    }

    public readonly calendar: ApiV0RmCalendar;
    public readonly company: ApiV0RmCompany;
}